<template>
  <div class="mobile" v-empty="empty" :empty-text="emptyText" ref="scroll" @scroll="handleScroll">
    <imgList :data="data" :type="2" v-if="show" :style="{margin: data.length > 0 ? '5px 0' : '0'}" />
    <div class="page-footer" :style="{paddingBottom: isFullScreen ? '34px' : '.07rem'}"
      v-if="collectFinish && data.length > 0">
      <hxm-footer type="text" :content="$t('2b496a8eac')"></hxm-footer>
    </div>
  </div>
</template>
<script>
import imgList from '@/components/mobile/mImgList';
import { getCollect } from '@/api/apiList';
import { throttle, uniqueArr } from '@/common';
export default {
  data() {
    return {
      value: '',
      onFocus: false,
      empty: '',
      emptyText: $t('9a79b39a1a'),
      data: [],
      collectFinish: false,
      collectId: '',
      show: true,
      top: 0,
      handleScroll: () => {},
      selectGroup: ''
    };
  },
  provide() {
    return {
      group: () => this.selectGroup,
    };
  },
  components: {
    imgList,
  },
  watch: {
    data(newValue, oldValue) {
      if (newValue.length == 0) {
        this.empty = 'm-collect';
        this.emptyText = $t('9a79b39a1a');
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      console.log(vm);
      document.title = $t('975ff67ee1');
      vm.data = [];
      vm.show = false;
      vm.collectId = '';
      vm.collectFinish = false;
      vm.$nextTick(() => {
        vm.show = true;
        vm.getData();
      });
    });
  },
  computed: {
    isFullScreen() {
      const testUA = str => window.navigator.userAgent.indexOf(str) > -1;
      console.log(testUA('iPhone'));
      return (
        window &&
        testUA('iPhone') &&
        window.screen.height >= 812 &&
        window.devicePixelRatio >= 2
      );
    },
  },
  methods: {
    scroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollHeight - scrollTop - clientHeight < 300) {
        console.log(scrollHeight - scrollTop - clientHeight, new Date());
        this.getData();
      }
    },
    scroll2(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      this.top = scrollTop > 0 ? scrollTop : this.top;
    },
    async getData() {
      if (this.collectFinish) {
        return;
      }
      let res = await getCollect({
        id: this.collectId,
        pageSize: 10,
      }).catch(error => {
        this.empty = 'm-error';
        this.emptyText = $t('866b795eae');
      });
      if (res && res.code === 1) {
        let { data } = res;
        if (data.length == 0) {
          this.collectFinish = true;
          return;
        }
        this.data = uniqueArr(this.data.concat(data));
        this.empty = '';
        this.collectId = data[data.length - 1].id;
      } else {
        this.empty = 'm-error';
        this.emptyText = $t('866b795eae');
      }
    },
  },
  created() {
    this.handleScroll = throttle(this.scroll, 500);
  },
  mounted() {
    this.$Bus.$on('collect-loadMore', () => {
      this.getData();
    });
    this.$Talog({
      id: `${window.platformPre}_tushuoshuju.wodeshoucang`,
    });
    const scrollview = this.$refs['scroll'];
    // 移除监听
    scrollview.addEventListener('scroll', this.scroll2, true);
  },
  beforeDestroy() {
    // 获取指定元素
    const scrollview = this.$refs['scroll'];
    // 移除监听
    scrollview.removeEventListener('scroll', this.scroll2, true);
  },
};
</script>
<style lang="less" scoped>
.mobile {
  height: 101%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: static;
}
.isBottom {
  width: 100%;
  height: 64px;
  background: #f5f5f5;
  .line {
    width: 59.8%;
    background-image: linear-gradient(
      to right,
      rgba(0, 0, 0, 0.24) 0%,
      rgba(0, 0, 0, 0.24) 100%
    );
    margin: 0 auto;
    background-size: 15px 1px;
    background-repeat: repeat-x;
    position: relative;
    background-position: center;
    /* top: 10px; */
    height: 16px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    position: relative;
    top: 12px;
    .text {
      background: #f5f5f5;
      color: rgba(0, 0, 0, 0.24);
    }
  }
}
.page-footer {
  position: relative;
  background-color: #f5f5f5;
  &::before {
    content: '';
    position: absolute;
    width: 40px;
    height: 1px;
    top: 23px;
    left: 50%;
    background-color: #ccc;
    transform: translateX(-80px);
  }
  &::after {
    content: '';
    position: absolute;
    width: 40px;
    height: 1px;
    top: 23px;
    left: 50%;
    background-color: #ccc;
    transform: translateX(36px);
  }
}
</style>
